import { Paper, PaperProps } from '@mui/material';
import { forwardRef, useImperativeHandle, useRef } from 'react';

interface CommandPalettePaperProps extends PaperProps {}

export interface CommandPalettePaperRef {
  shake: () => void;
}

const CommandPalettePaper = forwardRef(function CommandPalettePaper(
  props: CommandPalettePaperProps,
  ref: React.Ref<CommandPalettePaperRef>
) {
  const rootRef = useRef<HTMLDivElement>(null);

  useImperativeHandle(ref, () => ({
    shake: () => {
      if (rootRef.current) {
        rootRef.current.style.transform = 'scale(0.96)';
        setTimeout(() => {
          if (rootRef.current) {
            rootRef.current.style.transform = '';
          }
        }, 100);
      }
    },
  }));

  return (
    <Paper
      ref={rootRef}
      {...props}
      sx={{
        boxShadow:
          '0px 24px 56px -12px rgba(79, 89, 110, 0.2), 0px 8px 24px -18px rgba(79, 89, 110, 0.24), 0px 0px 24px 2px rgba(79, 89, 110, 0.16)',
        maxWidth: '640px',
        width: '100%',
        overflow: 'hidden',
        transition: 'transform 150ms ease',
        zIndex: 10,
        borderRadius: '12px',
        backgroundColor: 'white',
        border: (theme) => `1px solid ${theme.palette.border}`,
        top: '15vh',
        alignSelf: 'flex-start',
      }}
    />
  );
});

export default CommandPalettePaper;
